import { isMobile } from 'react-device-detect';

export default {
    sectionOffset: isMobile ? -160 : -180,
    menuOffset: isMobile ? 50 : 0,
    categoryIdPrefix: "section-",
    categoryNamePrefix: "name-",
    navItemIdPrefix: "navItem-",

};